import { createContext, useContext } from "react";
import { AlertColor } from "@mui/material";

type SnackbarContextType = {
  showSnack: (message: string, severity?: AlertColor) => void;
};

export const SnackbarContext = createContext<SnackbarContextType | undefined>(
  undefined
);

export const useSnack = (): ((
  message: string,
  severity?: AlertColor
) => void) => {
  const context = useContext(SnackbarContext);
  if (!context)
    throw new Error("useSnack must be used within a SnackbarProvider");
  return context.showSnack;
};
